/**
 * Checks if a given pathname is a public/auth route
 * @param pathname - Optional pathname to check. If not provided, uses window.location.pathname
 * @returns true if the route is a public/auth route, false otherwise
 */
export function isPublicRoute(pathname?: string): boolean {
  const path = (pathname || (typeof window !== 'undefined' ? window.location.pathname : '')).toLowerCase();
  const publicRoutes = ['/login', '/login-failed', '/refresh-failed', '/sso-login', '/login-success', '/'];
  return publicRoutes.some(route => path === route || path.startsWith(route + '/'));
}

